<mat-card *ngIf="ready(); else progressSpinner">
  <form>
    <mat-card-header>
      <mat-card-title>{{pageType | capitalize}} Problem</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <mat-card-subtitle class="student">Details</mat-card-subtitle>
      <mat-form-field>
        <input matInput placeholder="Name" [formControl]="problemForm.get('title')" required>
        <mat-error *ngIf="formService.controlHasError( problemForm.get('title'), 'required')">This field is required
        </mat-error>
        <mat-error *ngIf="formService.controlHasError( problemForm.get('title'), 'maxlength')">Max length of field exceeded
        </mat-error>
      </mat-form-field>

      <!-- TODO: Add to data model -->
      <mat-form-field>
        <input matInput placeholder="Display Name" [formControl]="problemForm.get('displayName')" required>
        <mat-error *ngIf="formService.controlHasError( problemForm.get('displayName'), 'required')">This field is required
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-auto">
        <mat-select placeholder="Subject" (selectionChange)="onSelectSubject()" [(ngModel)]="subjectSelected"
                    [ngModelOptions]="{standalone: true}" name="subject">
          <mat-option *ngFor="let subject of subjects" [value]="subject">
            {{ subject.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="topic-picker w-100">
        <input matInput placeholder="Type to select the topic" class="w-100"
               [matAutocomplete]="reactiveAuto"
               [formControl]="problemForm.get('topicDisplayName')"
               name="topic">

        <mat-autocomplete #reactiveAuto="matAutocomplete">
          <mat-option *ngFor="let topic of searchedTopics | async"
                      [value]="topic.displayName" (onSelectionChange)="setTopic(topic)">
            <span *ngIf="topic.displayName"> {{ topic.displayName }}</span>
            <small>Subject: {{topic.subject}}</small>
          </mat-option>
        </mat-autocomplete>
        <mat-icon matSuffix *ngIf="problemForm.get('topicDisplayName').value?.length > 0" (click)="clearTopicValue()">
          clear
        </mat-icon>
      </mat-form-field>

      <div>
        <mat-card-subtitle>Difficulty</mat-card-subtitle>
        <mat-slider min="1" max="5" step="1" discrete showTickMarks>
          <input matSliderThumb [formControl]="problemForm.get('difficulty')">
        </mat-slider>
        ( {{ problemForm.get('difficulty').value }} )
      </div>

      <mat-card-subtitle class="student">Content</mat-card-subtitle>

      <app-ck-editor [formControl]="problemForm.get('content')" [inline]="true"></app-ck-editor>
      <mat-error *ngIf="formService.controlHasError( problemForm.get('content'), 'required')">This field is required
      </mat-error>
      <mat-error *ngIf="formService.controlHasError( problemForm.get('content'), 'maxlength')">Max length of field exceeded
      </mat-error>

      <mat-form-field class="input-autocomplete">
        <input matInput placeholder="Type to select one passage" [matAutocomplete]="reactiveAuto2"
               [formControl]="problemForm.get('passageDisplayName')"
               name="topic">
        <mat-autocomplete #reactiveAuto2="matAutocomplete">
          <mat-option *ngFor="let passage of searchedPassages | async"
                      [value]="passage.title" (onSelectionChange)="setPassage(passage)">
            <span>{{ passage.title }}</span> |
            <!--Todo: transform the html  -->
            <small>Content: {{passage.content}}</small>
          </mat-option>
        </mat-autocomplete>
        <mat-icon matSuffix *ngIf="problemForm.get('passageDisplayName').value?.length > 0" (click)="clearPassageValue()">
          clear
        </mat-icon>
      </mat-form-field>

      <!-- TODO: Add to data model -->
      <mat-card-subtitle class="student">Explanation</mat-card-subtitle>
      <app-ck-editor [formControl]="problemForm.get('explanation')" [inline]="true" name="ckeditor"></app-ck-editor>

      <!--Solution List-->
      <app-solution-list class="solutions-section" *ngIf="pageType==='edit'" [solutions]="problemSolutions"></app-solution-list>
      <!--End Solution-->

    </mat-card-content>
    <mat-card-actions class="problem-actions" align="end">
      <button mat-raised-button color="primary" [disabled]="!problemForm.valid || isSubmitting" (click)="submitForm()">
        {{buttonName}}
      </button>
    </mat-card-actions>
</form>
</mat-card>

<ng-template #progressSpinner>
  <app-spinner></app-spinner>
</ng-template>
